export const SCROLLER_BATCH_SIZE = 25;
